<template>
  <BidangForm mode="Ubah" module="Bidang"> </BidangForm>
</template>

<script>
import BidangForm from './form';

const BidangUpdate = {
  name: 'BidangUpdate',
  components: { BidangForm },
};

export default BidangUpdate;
</script>
